import { memo, useMemo } from 'react'

import { useIsTabletS } from '@hooks/use-media-query'

import { Button } from './styles'

function CaseButtonComponent({
  label = 'View case study',
  bgColor,
  bgHover,
  textColor,
  textHover,
  textColorMobile,
}) {
  const isAboveTabletS = useIsTabletS()
  const color = useMemo(
    () => (!isAboveTabletS && textColorMobile ? textColorMobile : textColor),
    [isAboveTabletS, textColorMobile, textColor]
  )

  return (
    <Button
      bgColor={bgColor}
      bgHover={bgHover}
      textColor={color}
      textHover={textHover}
    >
      {label}
    </Button>
  )
}

export const CaseButton = memo(CaseButtonComponent)
